import React, { PureComponent } from "react";
import FormCore from "@/components/display/form/formCore";
import ScGridTable from "@/components/display/table/gridTableCore";
import PropTypes from "prop-types";
import moment from "moment";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import fetchHandler from "../../../fetch/fetchHandler";
// import { Tooltip } from 'antd';
import { stubErrorReport, stubFaultReportedlevelData, getCityList } from "../../../fetch/fetchApi";
import RefreshGrid from "../../../utils/refreshGrid";
// 国际化切换语言
// import { OPERATIONS_LEVEL } from '@/utils/mapObj';

// eslint-disable-next-line arrow-parens
@connect(state => state)
class FaultReportingList extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.faultReportingList;
    this.state = {
      visible: false,
      levelOption: [],
      formConfig: null,
      typeOption: [
        {
          text: this.props.intl.messages.faultReportingList.operationMode1, // '全部',
          value: "",
        },
      ],
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.getLevel();
    this.setState({
      formConfig: this.initFormConfig(),
    });
    this.init();
  }

  componentDidMount() {
    let param = {
      date:
        `${moment(new Date()).subtract(0, "d").format("YYYY-MM-DD")
        },${
          moment(new Date()).subtract(0, "d").format("YYYY-MM-DD")}`,
    };
    if (window.LayoutTab && window.LayoutTab.tabParam) {
      const date = window.LayoutTab.tabParam.date;
      param = {
        ...param,
        ...window.LayoutTab.tabParam,
        date: `${date[0].format("YYYY-MM-DD")},${date[1].format("YYYY-MM-DD")}`,
      };
    }
    this.fetchApi(param);
  }

  // 获取故障等级
  getLevel() {
    fetchHandler(stubFaultReportedlevelData, {
      type: "1",
    }).then((res) => {
      console.log(res);
      const list = res.data.map((item) => {
        const foo = {
          text: item.name,
          value: item.id,
        };
        return foo;
      });
      const first = {
        text: this.internationalization.operationMode1, // '全部',
        value: "",
      };
      list.unshift(first);
      this.setState(
        {
          levelOption: [...list],
        },
        () => {
          this.setState({
            formConfig: this.initFormConfig(),
          });
        },
      );
      this.init();
    });
  }

  init() {
    this.setState({
      tableConfig: {
        tableKey: "faultReportingListTable",
        tableColumns: [
          {
            name: this.internationalization.title7, // 7'设备编号',
            key: "stubId",
            colType: "textCol",
            align: "left",
          },
          {
            name: this.internationalization.title8, // '故障码',
            key: "code",
            colType: "textCol",
            align: "left",
          },
          {
            name: this.internationalization.title9, // '故障名称',
            key: "codeName",
            colType: "tipCol",
            align: "left",
          },
          {
            name: this.internationalization.title10, // '运维等级',
            colType: "textCol",
            align: "left",
            render: (value, row) => {
              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    padding: "0 22px",
                  }}>
                  <div className="tip-lv">
                    <span className="first" style={{ background: row.color }}></span>
                    <span className="last" style={{ background: row.color }}></span>
                  </div>
                  <span>{row.maintLevelName}</span>
                </div>
              );
            },
          },
          {
            name: this.internationalization.title11, // '次数',
            key: "cnt",
            align: "center",
            colType: "numCol",
          },
          {
            name: this.internationalization.title12, // '最新上报时间',
            key: "reportTimeLatest",
            colType: "textCol",
            align: "left",
          },
          {
            name: this.internationalization.title13, // '电站名称',
            key: "stubGroupName",
            colType: "tipCol",
            align: "left",
          },
          {
            name: this.internationalization.title14, // '地区',
            key: "cityName",
            colType: "textCol",
            align: "left",
          },
          // {
          //     name: '运营属性',
          //     key: "operationProperty",
          //     colType: 'textCol',
          //     align: 'center',
          //     render:(value,row,index)=>{
          //         if(value == '0'){
          //             return '运维'
          //         }else if(value == '1'){
          //             return '运营'
          //         }else{
          //             return '--'
          //         }
          //     }
          // },
          {
            name: this.internationalization.title15, // '运营类型',
            key: "operationMode",
            colType: "textCol",
            align: "left",
            render: (value, row) => {
              if (row.operationProperty.toString() === "1") {
                if (value.toString() === "0") {
                  return <div>运营-他营</div>;
                } else if (value.toString() === "1") {
                  return <div>运营-联营</div>;
                } else if (value.toString() === "2") {
                  return <div>运营-星充直营</div>;
                } else if (value.toString() === "3") {
                  return <div>运营-加盟直营</div>;
                } else if (value.toString() === "4") {
                  return <div>运营-互联互通</div>;
                } else if (value.toString() === "5") {
                  return <div>运营-人人电站</div>;
                } else {
                  return <div>--</div>;
                }
              } else if (row.operationProperty.toString() === "0") {
                if (value.toString() === "0") {
                  return <div>运维-私桩</div>;
                } else if (value.toString() === "1") {
                  return <div>运维-非私桩</div>;
                } else if (value.toString() === "2") {
                  return <div>--</div>;
                }
              } else {
                return "--";
              }
            },
          },
          {
            name: this.internationalization.title16, // '设备型号',
            key: "modelNo",
            colType: "textCol",
            align: "left",
            render: (value) => {
              if (value === "null") {
                return "--";
              } else {
                return value;
              }
            },
          },
          {
            name: "固件信息",
            colType: "textCol",
            align: "left",
            render: (value, row) => {
              const updateType = row.updateType === "null" ? "-" : row.updateType;
              const frameWork = row.frameWork === "null" ? "" : row.frameWork;

              const text = `${updateType}-${frameWork}`;
              return <div>{text}</div>;
            },
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
        },
        dataApi: stubErrorReport,
        autoRefresh: !1, // 设置为true 直接加载grid数据
      },
    });
  }

  initFormConfig = () => {
    const option1 = [
      {
        text: "全部",
        value: "",
      },
      {
        text: "星充直营",
        value: "2",
      },
      {
        text: "加盟直营",
        value: "3",
      },
      {
        text: "联营",
        value: "1",
      },
      {
        text: "他营",
        value: "0",
      },
      {
        text: "人人电站",
        value: "5",
      },
    ];

    const option2 = [
      {
        text: "全部",
        value: "",
      },
      {
        text: "私桩",
        value: "0",
      },
      {
        text: "非私桩",
        value: "1",
      },
    ];

    const option3 = [
      {
        text: "全部",
        value: "",
      },
    ];

    const formConfig = {
      childItems: [
        {
          type: "input",
          placeholder: this.internationalization.placeholder1, // '请输入故障名称',
          param: {
            name: "codeName",
            type: "string",
          },
          labelName: this.internationalization.title1, // '故障名称:',
          required: false,
        },
        {
          type: "input",
          placeholder: this.internationalization.placeholder2, // '请输入设备编号',
          param: {
            name: "stubId",
            type: "string",
          },
          labelName: this.internationalization.title2, // '设备编号:',
          required: false,
          defaultValue:
            window.LayoutTab && window.LayoutTab.tabParam && window.LayoutTab.tabParam.stubId,
        },
        {
          type: "areaPicker",
          isPickArea: !0,
          placeholder: this.internationalization.placeholder3, // '请选择地区',
          pickOnSelect: true,
          param: {
            name: "cityId", // 与form表单绑定的参数名
            type: "array",
          },
          // defaultValue: ['34'], //默认值
          required: !1,
          labelName: this.internationalization.title3, // '地区',
          className: "allshow",
          sourceApi: getCityList,
          mapKey: {
            label: "label",
            value: "value",
            children: "children",
          },
        },
        {
          type: "select",
          options: this.state.levelOption,
          placeholder: this.internationalization.placeholder, // '请选择:',
          param: {
            name: "maintLevelId",
            type: "string",
          },
          labelName: this.internationalization.title4, // '运维等级',
          required: !1,
        },
        {
          type: "inputGroup",
          isArray: true,
          inputGroup: [
            {
              type: "select",
              width: "95px",
              options: [
                {
                  text: this.internationalization.operationMode1, // '全部',
                  value: "",
                },
                {
                  text: "运营",
                  value: "1",
                },
                {
                  text: "运维",
                  value: "0",
                },
              ],
              placeholder: this.internationalization.placeholder, // '请选择',
              param: {
                name: "operationProperty",
                type: "string",
              },
              labelName: this.internationalization.title5, // '运营类型:',
              required: false,
              onChange: (value, form) => {
                form.setFieldsValue({
                  operationProperty: value,
                  operationMode: "",
                });
                console.log(value);
                const stubType2List = [];
                if (value === "0") {
                  stubType2List.push(...option2);
                } else if (value === "1") {
                  stubType2List.push(...option1);
                } else if (value === "") {
                  stubType2List.push(...option3);
                }
                this.setState(
                  {
                    typeOption: [...stubType2List],
                  },
                  () => {
                    this.setState({
                      formConfig: this.initFormConfig(),
                    });
                  },
                );
              },
            },
            {
              type: "select",
              width: "95px",
              placeholder: this.internationalization.placeholder, // '请选择',
              param: {
                name: "operationMode",
                type: "string",
              },
              labelName: "",
              options: this.state.typeOption,
              required: false,
            },
          ],
        },
        {
          type: "date",
          dateType: "rangeDate",
          allowClear: false,
          width: "200px",
          placeholder: ["年/月/日", "年/月/日"],
          param: {
            name: "date",
            type: "array",
          },
          defaultValue:
            window.LayoutTab && window.LayoutTab.tabParam && window.LayoutTab.tabParam.date
              ? window.LayoutTab.tabParam.date
              : [moment(new Date()).subtract(0, "d"), moment(new Date()).subtract(0, "d")],
          validator: {
            // 自定义校验对象
            vtype: "date", // 校验名称
            min_val: 0, // 可选最小天数
            // max_val: 7 // 可选最大天数
          },
          labelName: this.internationalization.title6, // '日期:',
          required: true,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "submit",
              // icon: 'search',
              text: this.internationalization.btn1, // '查询'
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      defaultParams: {},
      tableKey: "faultReportingListTable",
      tablePage: "故障上报",
    };

    return formConfig;
  };

  fetchApi = (param) => {
    console.log(param);
    const newParam = param;
    // if(param.cityId){

    //   let selectCity = (param.cityId && param.cityId.split(',')) || [];
    //   switch (selectCity.length) {
    //       case 1:
    //           newParam.cityId = selectCity[0] + '0000';
    //           break;
    //       case 2:
    //           newParam.cityId = selectCity[1] + '00';
    //           break;
    //       case 3:
    //           newParam.cityId = selectCity[2];
    //           break;
    //       default:
    //           newParam.cityId = "";
    //           break
    //   }
    // }
    const data = [param.date.split(",")[0], param.date.split(",")[1]];

    newParam.cityId = newParam.cityId === undefined
      ? ""
      : newParam.cityId
        .toString()
        .slice(
          newParam.cityId.toString().lastIndexOf(",") + 1,
          newParam.cityId.toString().length,
        );
    newParam.startTime = data[0];
    newParam.endTime = data[1];
    delete newParam.date;

    // 当设置formTarget为grid时，执行自定义提交事件。
    if (this.state.formConfig.formTarget === "grid") {
      return;
    }
    // 请求fetch 对象，带入生成参数
    // 如果在modal中的表单提交，请执行这里
    if (this.props.modalSubmit) {
      return this.props.modalSubmit(newParam);
    } else {
      // 如果正常页面中的表单提交，请执行下面
      return RefreshGrid(this.context.store, "faultReportingListTable", newParam);
    }
  }

  openTab(param, e) {
    this.props.onAdd.bind(window.LayoutTab)(e, param);
  }

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel gzsbTable">
          <ScGridTable config={this.state.tableConfig} />
        </div>
      </div>
    );

    return Content;
  }
}

export default injectIntl(FaultReportingList);



// WEBPACK FOOTER //
// ./src/AntD/pages/exceptionManagement/faultReporting/faultReportingList.js